import { Theme } from "@mui/material";

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    statusBadge: {
      background: "#FEE4E2 !important",
      border: "1px solid #E0E2E7",
      padding: "3px 10px",
      borderRadius: 20,
      height: 32,
      fontWeight: 600,
      fontSize: 10,
      lineHeight: "20px",
      color: "#F97066 !important",
    },
    statusBadgeActive: {
      background: "#D1FADF !important",
      border: "1px solid #D1FADF",
      color: "#32D583 !important",
    },
    button: {
      cursor: "pointer",
    },
    changeStatusButton: {
      whiteSpace: "nowrap",
      "& span > div": {
        display: "flex",
        alignItems: "center",
      },
    },
    main:{
      "& .shipeezi-new-grid-component":{
        "& > :nth-child(1)": {   
          "& > :nth-child(1)": {
           width:"unset"  
          },
        },
      }
    }
  }),
);
export default useStyles